import styles from './CardState.module.css';

export const CardLoading = ({ label }) => (
    <div className={styles.skeleton} role="status" aria-busy="true">
        <span className={styles.sr}>Loading {label}</span>
        <div className={styles.bar} />
        <div className={styles.bar} />
        <div className={styles.bar} />
    </div>
);

export const CardEmpty = ({ children }) => <p className={styles.empty}>{children}</p>;

export const CardError = ({ label, status, onRetry }) => (
    <div className={styles.error} role="alert">
        {status === 403 ? (
            <span>You don't have access to this.</span>
        ) : (
            <>
                <span>Couldn't load {label}.</span>
                <button type="button" className={styles.retry} onClick={onRetry}>
                    Retry
                </button>
            </>
        )}
    </div>
);
